module.exports = __webpack_public_path__ + "img/61c42dbf2e94c1bda6a6c9a1c774faff.png";